export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.a38f1e239975ac431bfca9fe9489638f.css";